import dayjs from 'dayjs';
import { Button } from 'flowbite-react';
import React from 'react';
import { PiUsersFill } from 'react-icons/pi';
import { Img } from 'react-image';
import { useNavigate } from 'react-router-dom';
import { GetUIContestByIdAPIResponse } from 'types';

const PastContestCard = ({ contest }: { contest: GetUIContestByIdAPIResponse['contest'] }) => {
	const navigate = useNavigate();

	return (
		<div
			key={contest._id}
			className="flex min-h-[160px] min-w-[95%] w-full p-4 relative isolate rounded-[8px] border dark:border-[#3F3F3F] border-[#EBEBF0] bg-white dark:bg-[#1F2A37]"
		>
			<img
				src={'/assets/pastContestBg.svg'}
				className="rounded-[inherit] absolute h-full w-full inset-0 z-[-1] hidden dark:block"
				alt=""
			/>
			<img
				src={'/assets/pastContestBgLight.svg'}
				className="rounded-[inherit] absolute h-full w-full inset-0 z-[-1] dark:hidden"
				alt=""
			/>

			<div className="flex-1 max-w-[80%] flex flex-col">
				<h2 className="text-xl font-bold ">{contest.title}</h2>

				<div className="flex text-[14px] dark:text-[#F2F2F5] text-[#555770] max-w-[80%] font-[400] items-center flex-wrap gap-1 mt-[9px]">
					<span>{dayjs(contest.startDate).format('DD MMM, hh:mm a')}</span>
					{contest.totalRegistrations ? (
						<>
							<span className="dark:text-[#F2F2F5] text-[6px] font-[400]">●</span>
							<span className="flex items-center gap-1">
								<PiUsersFill className="text-[#73DFE7] w-[16px] h-[16px]" />{' '}
								{contest?.totalRegistrations?.toLocaleString()} participated
							</span>
						</>
					) : null}
				</div>

				<div className="mt-auto w-max">
					<Button
						color="whiteBlue"
						size={''}
						className="px-[20px] py-[10px] max-h-[36px] bg-[#FFF] dark:bg-[#1F2A37] border border-[#5B8DEF] text-[#28293D] dark:text-[#FFF]"
						onClick={() => {
							navigate(`/contests/${contest._id}`);
						}}
					>
						View Results
					</Button>
				</div>
			</div>

			<div className="absolute bottom-0 right-0 h-full w-full flex justify-end items-center max-w-[161px] tmd:max-w-[342px] ml-auto">
				<div className="absolute text-center ml-auto flex items-center mr-[15%]">
					<img src="/assets/codeIcon.svg" className="pointer-events-none my-auto" alt="" />
					{!+contest.title?.split('#')[1] ? null : (
						<p className="text-xl font-[400] absolute bottom-[-30%] right-[12px] text-transparent [background-image:_linear-gradient(147deg,_#73DFE7_6.95%,_#0063F7_93.05%)] bg-clip-text">
							#{contest.title?.split('#')[1]}
						</p>
					)}
				</div>
				<Img
					src="https://masai-website-images.s3.ap-south-1.amazonaws.com/card_bg_ecf4859646.png"
					className="w-full h-full object-contain object-right-bottom relative z-[-2]"
				/>
			</div>
		</div>
	);
};

export default PastContestCard;
